import React, { useRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useReactToPrint } from "react-to-print";
import SubHeader from "../../../../_psb/layout/sub-header/SubHeader";
import Content from "../../../../_psb/layout/Content";

import ReportsContent from "./ReportsContent";

import styled from "@emotion/styled";
import {
  artisansIsLoadingSelector,
  artisansCountSelector,
} from "../../../../modules/reports/artisans/Selectors";

import { getArtisansReportsAction } from "../../../../modules/reports/artisans/Actions";

// Content

const ArtisansReports = ({ getArtisans, isLoading, count }) => {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Artisans Reports",
    bodyClass : "react-to-print__body-class"
    
  });

  const [offset, setOffset] = useState(0);
  const totalPages = Math.round(count / 13);
  const [currentPage, setCurrentPage] = useState(() => offset / 13 + 1);

  useEffect(() => {
    getArtisans({
      size: 13,
      offset,
    });

    setCurrentPage(offset / 13 + 1);
  }, [getArtisans, offset]);

  const handleNext = () => {
    setOffset((value) => value + 13);
  };

  const handlePrev = () => setOffset((value) => value - 13);

  const handleChange = (e) => {
    setCurrentPage(Number(e.target.value));
  };

  const handleBlur = (e) => {

    if (isNaN((Number(currentPage) - 1) * 13)) {
      return;
    }

    setOffset((Number(currentPage) - 1) * 13);
    
  }

  return (
    <>
      <SubHeader
        title='users reports'
        Component={() => {
          return (
            <>
              <span className='kt-subheader__separator kt-subheader__separator--v'></span>

              <button
                disabled={isLoading}
                className='btn btn-sm btn-primary btn-shadow-hover d-flex'
                onClick={handlePrint}
              >
                <i className=' flaticon-technology '></i>Print
              </button>
            </>
          );
        }}
      >
        <Search>
          <input
            onChange={handleChange}
            onBlur={handleBlur}
            value={currentPage}
          />{" "}
          <span className='slash'>/</span>{" "}
          <span className='total_pages'>{totalPages}</span>
        </Search>
        <button
          disabled={isLoading || offset === 0}
          type='button'
          className='btn btn-sm btn-secondary btn-shadow-hover d-inline-flex mr-2'
          onClick={handlePrev}
        >
          <i className='flaticon2-left-arrow '></i> Previous
        </button>

        <button
          disabled={isLoading || offset / 13 + 1 === totalPages}
          type='button'
          className='btn btn-sm btn-secondary btn-shadow-hover d-inline-flex'
          onClick={handleNext}
        >
          Next <i className='flaticon2-right-arrow float-right ml-1'></i>
        </button>
      </SubHeader>

      <Content>
        {/*  <Header className='row d-flex justify-content-between'>
          <button
            className='btn btn-sm btn-primary btn-shadow-hover d-flex'
            onClick={handlePrint}
          >
            <i className=' flaticon-technology '></i>Print
          </button>

          <div>
            <button className='btn btn-sm btn-secondary btn-shadow-hover d-inline-flex mr-2'>
              <i className='flaticon2-left-arrow '></i> Previous
            </button>

            <button
              type='button'
              className='btn btn-sm btn-secondary btn-shadow-hover d-inline-flex'
              onClick={handleNext}
            >
              Next <i className='flaticon2-right-arrow float-right ml-1'></i>
            </button>
          </div>
        </Header> */}

        {/**
         * Content To Print
         */}
        <ReportsContent ref={componentRef} />
      </Content>
    </>
  );
};

const mapDispatchToProps = {
  getArtisans: getArtisansReportsAction,
};

const mapStateToProps = (state) => {
  return {
    isLoading: artisansIsLoadingSelector(state),
    count: artisansCountSelector(state),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ArtisansReports);

const Header = styled.div`
  background-color: #fff;
  padding: 5px;
  position: sticky;
  width: 100%;
  top: 118px;
`;

const Search = styled.div`
  width: 210px;

  input {
    display: inline-block;
    width: 100px;
  }
  .slash {
    display: inline-block;
    width: 20px;
  }
  .total_pages {
    display: inline-block;
    width: 80px;
  }
`;
